import { FC } from 'react';
import { Close } from '@mui/icons-material';
import { IconButton, styled, Tooltip } from '@mui/material';

const StyledIconButton = styled(IconButton)`
  position: absolute;
  top: ${({ theme }) => theme.spacing(0.5)};
  right: ${({ theme }) => theme.spacing(0.5)};
`;

type Props = {
  onClick: () => void;
};

export const MediaCardRemoveButton: FC<Props> = ({ onClick }) => (
  <Tooltip title="Remove" arrow placement="top">
    <StyledIconButton
      onClick={(e) => {
        e.stopPropagation();
        e.preventDefault();
        onClick();
      }}
      size="small"
    >
      <Close fontSize="small" />
    </StyledIconButton>
  </Tooltip>
);
